import type { StoreApi } from "zustand";
import { createCoreActions } from "../slices/actions/core-actions";
import { createDynamicFieldActions } from "../slices/actions/dynamic-field-actions";
import { createLifecycleActions } from "../slices/actions/lifecycle-actions";
import { createValidationActions } from "../slices/actions/validation-actions";
import type { FormActions, FormStore, SliceSetFunction } from "../types";
import { createDynamicCollectionSlice } from "./dynamic-collection-slice";
import { createOptionalCollectionSlice } from "./optional-collection-slice";

/**
 * アクションスライスの作成
 * フォームの状態を変更するアクションを提供
 */
export const createActionsSlice = (
  set: SliceSetFunction,
  get: () => FormStore,
  api: StoreApi<FormStore>,
): FormActions => {
  // 各種アクションをインポート
  const coreActions = createCoreActions(set, get, api);
  const validationActions = createValidationActions(set, get, api);
  const lifecycleActions = createLifecycleActions(set, get);
  const dynamicFieldActions = createDynamicFieldActions(set, get, api);
  const optionalCollectionActions = createOptionalCollectionSlice(
    set,
    get,
    api,
  );
  const dynamicCollectionActions = createDynamicCollectionSlice(set, get, api);

  // 全アクションを結合して返す
  return {
    ...coreActions,
    ...validationActions,
    ...lifecycleActions,
    ...dynamicFieldActions,
    ...optionalCollectionActions,
    ...dynamicCollectionActions,
  };
};
